// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2C66N","question":"Question_question__2v5Cx","description":"Question_description__v_vyO"};